__turbopack_context__.v({
  "arrowIcon": "FoundationView-module__vvaVfG__arrowIcon",
  "container": "FoundationView-module__vvaVfG__container",
  "divider": "FoundationView-module__vvaVfG__divider",
  "grid": "FoundationView-module__vvaVfG__grid",
  "leftColumn": "FoundationView-module__vvaVfG__leftColumn",
  "page": "FoundationView-module__vvaVfG__page",
  "paragraph": "FoundationView-module__vvaVfG__paragraph",
  "paragraphRow": "FoundationView-module__vvaVfG__paragraphRow",
  "rightBlock": "FoundationView-module__vvaVfG__rightBlock",
  "rightColumn": "FoundationView-module__vvaVfG__rightColumn",
  "rightParagraph": "FoundationView-module__vvaVfG__rightParagraph",
  "section": "FoundationView-module__vvaVfG__section",
  "subheading": "FoundationView-module__vvaVfG__subheading",
  "title": "FoundationView-module__vvaVfG__title",
  "titleBrand": "FoundationView-module__vvaVfG__titleBrand",
  "titleMain": "FoundationView-module__vvaVfG__titleMain",
});
